import core, { GQL, App } from '@gin-betting/core';

import { ACTIVE_MARKET_STATUSES } from 'app-constants';

const { appServiceLocator } = core;

async function fetchOutrightsByTournamentIds(
    tournamentIds: string[],
    retriesLeft: number = 3,
    retryInterval: number = 1000
): Promise<App.TypedFetchResult<GQL.GetMatchesByFiltersQuery>> {
    const apiClient = appServiceLocator.get('apiClient');

    try {
        return await apiClient.makeRequest({
            method: 'getMatchesByFilters',
            variables: {
                tournamentIds,
                marketStatuses: ACTIVE_MARKET_STATUSES,
                matchStatuses: [
                    GQL.SportEventStatus.NOT_STARTED,
                    GQL.SportEventStatus.SUSPENDED,
                ],
                sportEventTypes: [GQL.SportEventType.OUTRIGHT],
                limit: 20,
                offset: 0,
                // NOTE: null stands for empty filter to override default value defined in GQL file
                marketLimit: null,
            },
        });
    } catch (err) {
        if (retriesLeft < 1) {
            return err;
        }

        await new Promise(resolve => setTimeout(resolve, retryInterval));

        return fetchOutrightsByTournamentIds(tournamentIds, retriesLeft - 1);
    }
}

export default fetchOutrightsByTournamentIds;
